'use strict';
module.exports = /^#!.*/;



/*****************
 ** WEBPACK FOOTER
 ** ./~/shebang-regex/index.js
 ** module id = 3264
 ** module chunks = 0
 **/